import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/(marketplace)/about/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/PublicUI/components/ButtonLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/ImageWithFallback/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/TestimonialsCarousel/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/Testimonial/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/LogosStrip/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
